import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import { isBrowser } from "../../../context/ApolloContext"
import { useLocation } from "@reach/router"

const OffreFlashStickyBannerWrapper = styled.div`
  width: 100%;
  padding: 8px 20px;
  font-size: 18px;
  text-align: center;
  background: ${props => props.theme.saleColor.bgColor};
  color: ${props => props.theme.saleColor.textColor};
  // background: #ffed7d;
  // color: #000
  overflow: hidden;
  min-height: 53px;
  display: flex;

  @media (max-width: 720px) {
    min-height: 50px;
  }

  @media (max-width: 480px) {
    min-height: 44px;
  }

  @media (max-width: 450px) {
    padding: 8px 10px;
  }

  @media (max-width: 350px) {
    min-height: 40px;
  }
`

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const LeftText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Gotham";
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  margin: 0px 15px 0px 0px;

  span {
    font-family: "Gotham Book";
    font-weight: 500;
    letter-spacing: 1.5px;

    @media (max-width: 400px) {
      letter-spacing: 1.5px;
    }
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (max-width: 340px) {
    margin: 0px 10px 0px 0px;
  }
`

const RightText = styled.div`
  font-family: "Gotham Book";
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  text-align: center;
  // margin: 3px 0px 0px 0px;

  strong {
    font-weight: 900;
  }

  span:nth-of-type(2) {
    @media (max-width: 600px) {
      display: block;
    }
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: 14px;
  }
`

const OffreFlashStickyBanner = ({ intl }) => {
  const [isLynePage, setisLynePage] = useState(false)
  const [isChaisePage, setisChaisePage] = useState(false)

  const { pathname } = useLocation()

  const checkButtonVisibility = () => {
    let currentPath = ""
    let lyneRegex =
      /(lyneup|lynefit|lynehome|wearable-technology|solutions-textiles)/
    let chaiseRegex = /(chaise-bureau-ergonomique|chaise-gaming)/

    currentPath = window.location.pathname

    setisLynePage(lyneRegex.test(currentPath))
    setisChaisePage(chaiseRegex.test(currentPath))
  }

  useEffect(() => {
    isBrowser && checkButtonVisibility()
  }, [pathname])
  return (
    <OffreFlashStickyBannerWrapper className="LyneHomeStickyBanner">
      <Container>
        {isChaisePage ? (
          <>
            <LeftText>
              OFFRE D’HIVER <span>Derniers jours</span>
            </LeftText>
            <RightText>
              <strong>-100€</strong> sur la chaise
            </RightText>
          </>
        ) : isLynePage ? (
          <>
            <LeftText>
              OFFRE D’HIVER <span>Derniers jours</span>
            </LeftText>
            <RightText>
              <span>
                <strong>-50%</strong>{" "}
              </span>
              <span>
                sur le 2<sup>e</sup> <span>produit</span>
              </span>
            </RightText>
          </>
        ) : (
          <>
            <LeftText>
              OFFRE D’HIVER <span>Derniers jours</span>
              {/* OFFRE LIMITÉE */}
              {/* DERNIERS JOURS */}
            </LeftText>
            <RightText>
              <span>
                <strong>-25% sur tout le site</strong>{" "}
              </span>
              <span>dès 150€ d’achat</span>
              {/* <span>
                <strong>-10%</strong> supplémentaires{" "}
              </span>
              <span>
                avec le code <strong>PLUS</strong>
              </span> */}
            </RightText>
          </>
        )}
      </Container>
    </OffreFlashStickyBannerWrapper>
  )
}

export default injectIntl(OffreFlashStickyBanner)
